import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    messages: [],
    chatTitle: '',
    ticketStatus: '',
    ticket_id: '',
    newMessage: 0
};
const supportTicketSlice = createSlice({
    name: 'supportTicket',
    initialState: initialState,
    reducers: {
        setMessageHistory: (state, action) => {
            state.messages = action.payload;
        },
        setTitle: (state, action) => {
            state.chatTitle = action.payload;
        },
        setTicketStatus: (state, action) => {
            state.ticketStatus = action.payload;
        },
        setTicketId: (state, action) => {
            state.ticket_id = action.payload;
        },
        setNewMessage: (state, action) => {
            state.newMessage = action.payload;
        },
    },
});

export const { setMessageHistory, setTitle, setTicketStatus, setTicketId, setNewMessage } = supportTicketSlice.actions;
const supportTicketReducer = supportTicketSlice.reducer;
export default supportTicketReducer;
